import React from "react";
import PropTypes from "prop-types";
import * as types from "../../constants/ComponentConstants";
import Tooltip from "./Tooltip";

const Section = (props) => {
	let sectionclassName = props.color ? "c-section ia c-section--" + props.color : "c-section ia";
	sectionclassName = props.disabled ? sectionclassName + " disabled" : sectionclassName;
	const style = props.style || {};

	const tooltip = props.tooltip
		? <Tooltip
			text={props.tooltip}
			tooltipType={types.TOOLTIP_INFO}
			windowWidth={props.tooltipWindowWidth}
			windowAlignRight={props.tooltipWindowAlignRight}
			tooltipColor={props.tooltipColor}
			iconColor={props.iconColor}
		/>
		: null;

	const header = props.title ? (
		<header className="c-section__header">
			<h3 className="title">{props.title}{tooltip}</h3>
		</header>) : null;

	return (
		<div className="c-section-wrap" style={style}>
			<div className={sectionclassName}>
				{header}
				<div className="c-section__body">
					{props.children}
				</div>
			</div>
		</div>
	);
};

Section.propTypes = {
	iconColor: PropTypes.string,
	title: PropTypes.string,
	style: PropTypes.object,
	color: PropTypes.string,
	children: PropTypes.node,
	disabled: PropTypes.bool,
	tooltipColor: PropTypes.string,
	tooltip: PropTypes.string,
	tooltipWindowWidth: PropTypes.number,
	tooltipWindowAlignRight: PropTypes.bool
};

export default Section;
